module.exports = __webpack_public_path__ + "img/blc-poster.08973af0.jpg";